import {combine} from 'effector';
import {createGate} from 'effector-react';

import {fetchDocumentProductsGrid} from 'api';
import {createTableModel} from 'core/hooks/table';
import {rootDomain} from 'core/rootDomain';
import {ProductContentRawRow} from 'types';

const domain = rootDomain.createDomain('DocumentsProductTableDomain');

export const Gate = createGate<{reportId: string}>('DocumentsProductTableGate');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchDocumentProductsGrid,
});
export const fetchTotalCountFx = domain.createEffect({
    name: 'fetchTotalCountFx',
    handler: fetchDocumentProductsGrid,
});

export const {
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    filters$,
    filtersChanged,
    sorting$,
    sortingChanged,
} = createTableModel({
    domain,
});

export const data$ = domain.createStore<ProductContentRawRow[]>([]);
export const totalCount$ = domain.createStore<number>(0);

export const state$ = combine({
    data: data$,
    totalCount: totalCount$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    sorting: sorting$,
    isLoading: fetchDataFx.pending || fetchTotalCountFx.pending,
});
